import styled from 'styled-components'

const LmcBackgroundLogo = () => (
  <BackgroundSvg
    width="340"
    height="322"
    viewBox="0 0 340 322"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.25">
      <path
        d="M112.489 65.0459C112.489 73.7018 112.832 82.1881 113.346 90.5046C125.716 97.8885 136.532 107.57 145.199 119.018C200.686 189.963 222.95 322.009 222.95 322.009C222.95 322.009 302.07 176.046 302.07 65.0459C302.07 -82.9541 112.489 -88.3853 112.489 65.0459Z"
        fill="currentColor"
      />
      <path
        d="M113.345 90.5046C41.7598 48.7523 -42.1559 127.165 24.1204 212.028C104.611 315.051 222.949 322.009 222.949 322.009C222.949 322.009 124.134 236.468 113.345 90.5046Z"
        fill="currentColor"
      />
      <path
        d="M369.032 233.413C359.143 243.754 347.214 251.968 333.986 257.545C320.757 263.122 306.513 265.942 292.138 265.83C291.241 251.593 293.319 237.326 298.239 223.921C303.16 210.515 310.819 198.26 320.736 187.922C330.654 177.583 342.617 169.384 355.877 163.836C369.137 158.288 383.41 155.511 397.803 155.679C398.631 169.898 396.505 184.134 391.556 197.505C386.607 210.876 378.941 223.098 369.032 233.413Z"
        fill="currentColor"
      />
    </g>
  </BackgroundSvg>
)

export default LmcBackgroundLogo

const BackgroundSvg = styled.svg`
  position: absolute;
  bottom: 0;
  right: 0;
  top: 0;
  height: 100%;
  z-index: 0;
`
